import React from 'react';
import BaseErrorBoundary from '../BaseErrorBoundary';
import ComponentErrorFallback from './ComponentErrorFallback';

class ComponentErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      remountKey: 0
    };
  }

  handleRefresh = () => {
    this.setState(prevState => ({
      remountKey: prevState.remountKey + 1
    }));
  };

  render() {
    const { children, ...otherProps } = this.props;
    
    return (
      <BaseErrorBoundary
        key={this.state.remountKey} // Force new BaseErrorBoundary instance, this will unmount the children component and remount it
        errorFallbackComponent={otherProps.errorFallbackComponent || ComponentErrorFallback}
        errorIdPrefix="COMP_ERR_"
        reportType="Component Error Report"
        onRetry={this.handleRefresh}
        {...otherProps}
      >
        {children}
      </BaseErrorBoundary>
    );
  }
}

export default ComponentErrorBoundary;
